module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"provincia":"Provincia","altitud":"Altitud (metros)","climatica_consid":"Zona climática considerada","anyo_construccion":"Año de construcción","estado_conservacion":"Estado de conservación","revestimiento_existente":"Revestimiento existente"}}')
  delete Component.options._Ctor
}
